import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TextFormatIcon(props: IconProps) {
    return <Icon {...props} iconKey={"text_format"}/>
}
